import React from 'react';
export function ChampionStory() {
  return <section id="historia-campeon" className="w-full bg-[#0a0a0a] py-24 sm:py-28 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-1">
      <div className="max-w-7xl mx-auto" data-id="element-2">
        {/* Section Header */}
        <div className="text-center mb-16 sm:mb-20" data-id="element-3">
          <div className="inline-flex items-center gap-2 bg-[#C9A84C]/10 border border-[#C9A84C]/30 px-4 py-1.5 mb-6" data-id="element-4">
            <span className="w-2 h-2 rounded-full bg-[#C9A84C]" data-id="element-5" />
            <span className="text-[#C9A84C] font-body text-xs tracking-widest uppercase font-medium" data-id="element-6">
              Caso real · Kerchak Fighters Team
            </span>
          </div>
          <h2 className="font-heading font-bold text-white uppercase text-3xl sm:text-4xl lg:text-5xl xl:text-6xl tracking-tight leading-tight mb-4" data-id="element-7">
            Historias que inspiran.
            <br className="hidden sm:block" data-id="element-8" />
            <span className="text-[#C9A84C]" data-id="element-9"> Títulos que respaldan.</span>
          </h2>
          <p className="font-body text-gray-400 text-base sm:text-lg max-w-xl mx-auto italic leading-relaxed" data-id="element-10">
            Aquí no entrenamos por entrenar. Formamos competidores reales.
          </p>
          <div className="section-divider mt-6" data-id="element-11" />
        </div>

        {/* Main Featured Story Block */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 lg:gap-16 xl:gap-20 items-center" data-id="element-12">
          {/* Left: Cinematic Image */}
          <div className="relative mb-10 lg:mb-0" data-id="element-13">
            {/* Outer glow/border effect */}
            <div className="absolute -inset-px bg-gradient-to-b from-[#C9A84C]/20 via-transparent to-[#C9A84C]/10 rounded-none pointer-events-none z-10" data-id="element-14" />

            {/* Image container */}
            <div className="relative overflow-hidden" style={{
            aspectRatio: '3/4'
          }} data-id="element-15">
              <img src="https://cdn.magicpatterns.com/uploads/rAEz36GQ7rkRHcxoNRr1NG/KST06532_copia.jpg" alt="Campeón de Canarias Profesional - Kerchak Fighters Team" className="w-full h-full object-cover object-top" data-id="element-16" />
              {/* Bottom gradient overlay for depth */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a]/60 via-transparent to-black/20" data-id="element-17" />
              {/* Left edge vignette */}
              <div className="absolute inset-0 bg-gradient-to-r from-black/20 via-transparent to-transparent" data-id="element-18" />

              {/* Champion badge overlay on image */}
              <div className="absolute bottom-6 left-6 right-6" data-id="element-19">
                <div className="inline-flex items-center gap-2 bg-black/70 backdrop-blur-sm border border-[#C9A84C]/50 px-4 py-2" data-id="element-20">
                  <span className="text-[#C9A84C] text-lg" data-id="element-21">🥇</span>
                  <span className="font-heading font-bold text-[#C9A84C] uppercase text-sm tracking-widest" data-id="element-22">
                    Campeón de Canarias Profesional
                  </span>
                </div>
              </div>
            </div>

            {/* Decorative gold line left */}
            <div className="hidden lg:block absolute -left-4 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#C9A84C]/40 to-transparent" data-id="element-23" />
          </div>

          {/* Right: Story Content */}
          <div className="flex flex-col justify-center px-0 sm:px-2 lg:px-0" data-id="element-24">
            {/* Internal title */}
            <h3 className="font-heading font-bold text-white uppercase text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-tight mb-8" data-id="element-25">
              De 7 años retirado
              <br data-id="element-26" />
              <span className="text-[#C9A84C]" data-id="element-27">
                a campeón profesional invicto
              </span>
            </h3>

            {/* Stats — punchy lines */}
            <div className="space-y-3 mb-10" data-id="element-28">
              <div className="flex items-baseline gap-4" data-id="element-29">
                <span className="flex-shrink-0 w-6 h-px bg-[#C9A84C] mt-1 relative top-[-3px]" data-id="element-30" />
                <span className="font-heading font-bold text-white uppercase text-xl sm:text-2xl tracking-wide" data-id="element-31">
                  40 años.
                </span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-32">
                <span className="flex-shrink-0 w-6 h-px bg-[#C9A84C] mt-1 relative top-[-3px]" data-id="element-33" />
                <span className="font-body text-gray-300 text-base sm:text-lg leading-snug" data-id="element-34">
                  7 años sin tocar un gimnasio.
                </span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-35">
                <span className="flex-shrink-0 w-6 h-px bg-[#C9A84C] mt-1 relative top-[-3px]" data-id="element-36" />
                <span className="font-body text-gray-300 text-base sm:text-lg leading-snug" data-id="element-37">
                  Regreso desde cero.
                </span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-38">
                <span className="flex-shrink-0 w-6 h-px bg-[#C9A84C] mt-1 relative top-[-3px]" data-id="element-39" />
                <span className="font-body text-gray-300 text-base sm:text-lg leading-snug" data-id="element-40">
                  Paso a profesional.
                </span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-41">
                <span className="flex-shrink-0 w-6 h-px bg-[#C9A84C] mt-1 relative top-[-3px]" data-id="element-42" />
                <span className="font-heading font-bold text-white uppercase text-xl sm:text-2xl tracking-wide" data-id="element-43">
                  6 victorias consecutivas.
                </span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-44">
                <span className="flex-shrink-0 w-6 h-px bg-[#C9A84C] mt-1 relative top-[-3px]" data-id="element-45" />
                <span className="font-heading font-bold text-[#C9A84C] uppercase text-xl sm:text-2xl tracking-wide" data-id="element-46">
                  Campeón de Canarias profesional.
                </span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-47">
                <span className="flex-shrink-0 w-6 h-px bg-[#C9A84C]/50 mt-1 relative top-[-3px]" data-id="element-48" />
                <span className="font-body text-gray-400 text-base sm:text-lg leading-snug italic" data-id="element-49">
                  Próximo objetivo: Campeonato de España.
                </span>
              </div>
            </div>

            {/* Divider */}
            <div className="w-full h-px bg-gradient-to-r from-[#C9A84C]/40 via-[#C9A84C]/20 to-transparent mb-8" data-id="element-50" />

            {/* Featured Quote */}
            <blockquote className="mb-10" data-id="element-51">
              <span className="font-heading text-[#C9A84C] text-5xl leading-none opacity-60 block mb-1" data-id="element-52">
                "
              </span>
              <p className="font-heading font-bold text-[#C9A84C] uppercase text-2xl sm:text-3xl lg:text-2xl xl:text-3xl tracking-tight leading-tight" data-id="element-53">
                La edad es un número.
                <br data-id="element-54" />
                La mentalidad es una decisión.
              </p>
            </blockquote>

            {/* CTA */}
            <div className="flex flex-col items-start sm:items-start" data-id="element-55">
              <a href="#precios" className="bg-[#C9A84C] hover:bg-[#E8C97A] text-black font-heading font-bold px-8 py-4 text-lg tracking-widest uppercase transition-all duration-200 shadow-lg shadow-[#C9A84C]/25 hover:shadow-[#C9A84C]/40 hover:scale-105 inline-block" data-id="element-56">
                Reservar Primera Clase
              </a>
              <span className="text-gray-500 text-xs mt-2 font-body italic" data-id="element-57">
                Elige día y hora en 30 segundos.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}